export const BRAND_WEB_VARIANTS = [
  {
    id: "corporate",
    label: "기업",
    title: "기업 홈페이지",
    url: "game-studio.dsite",
    description: "IT·제조·금융·호텔 등 다양한 기업·기관 홈페이지 제작 사례",
    accent: "#1a365d",
    preview: "linear-gradient(135deg,#edf2f7,#cbd5e0)",
  },
  {
    id: "restaurant",
    label: "음식점",
    title: "음식점 홈페이지",
    url: "atelier-yuga.dsite",
    description: "파인다이닝·한식·일식·카페 등 음식점·F&B 홈페이지 제작 사례",
    accent: "#ff6a1a",
    preview: "linear-gradient(135deg,#0a0807,#1e3932)",
  },
  {
    id: "cafe",
    label: "카페",
    title: "카페 홈페이지",
    url: "terarosa.com",
    description: "스페셜티·로스터리·프랜차이즈 등 카페 홈페이지 제작 사례",
    accent: "#00704a",
    preview: "linear-gradient(135deg,#d4e9e2,#00704a)",
  },
  {
    id: "hospital",
    label: "병원",
    title: "병원 홈페이지",
    url: "general-hospital.dsite",
    description: "종합병원·치과·검진센터 등 의료 홈페이지 제작 사례",
    accent: "#1e3a5f",
    preview: "linear-gradient(135deg,#e8f4f8,#d4e8f0)",
  },
  {
    id: "education",
    label: "교육·학원",
    title: "교육·학원 홈페이지",
    url: "studyflow.dsite",
    description: "학원·교육기관·온라인 강의 홈페이지 제작 사례",
    accent: "#4f46e5",
    preview: "linear-gradient(135deg,#eef2ff,#c7d2fe)",
  },
  {
    id: "commerce",
    label: "쇼핑몰",
    title: "쇼핑몰·커머스",
    url: "shop.dsite",
    description: "브랜드몰·자사몰·커머스 랜딩 페이지 제작 사례",
    accent: "#db2777",
    preview: "linear-gradient(135deg,#fdf2f8,#fbcfe8)",
  },
  {
    id: "real-estate",
    label: "부동산",
    title: "부동산 홈페이지",
    url: "realty.dsite",
    description: "부동산·분양·임대 매물 안내 홈페이지 제작 사례",
    accent: "#0d9488",
    preview: "linear-gradient(135deg,#f0fdfa,#99f6e4)",
  },
  {
    id: "beauty-health",
    label: "미용·헬스",
    title: "미용·헬스 홈페이지",
    url: "beauty-health.dsite",
    description: "미용실·피트니스·웰니스 브랜드 홈페이지 제작 사례",
    accent: "#be185d",
    preview: "linear-gradient(135deg,#fdf2f8,#fbcfe8)",
  },
  {
    id: "startup",
    label: "스타트업·SaaS",
    title: "스타트업·SaaS",
    url: "startup-saas.dsite",
    description: "스타트업·SaaS·서비스 소개 랜딩 페이지 제작 사례",
    accent: "#6366f1",
    preview: "linear-gradient(135deg,#eef2ff,#c7d2fe)",
  },
];

export const DEFAULT_BRAND_WEB_VARIANT = "corporate";

export function getBrandWebVariant(id) {
  return BRAND_WEB_VARIANTS.find((v) => v.id === id) ?? BRAND_WEB_VARIANTS[0];
}

export function isValidBrandWebVariant(id) {
  return BRAND_WEB_VARIANTS.some((v) => v.id === id);
}
